import styled from 'styled-components';

import { WithThemeProps } from '../../styles';


type ControlsLayoutProps = {
	fullWidth: boolean;
}

type ButtonProps = {
	isActive: boolean;
	fullWidth: boolean;
} & WithThemeProps

type SliderBarProps = {
	width: number;
	offset: number;
}

type SliderProps = {
	negativeOffset: number;
}

const Root = styled.div`
	position: relative;
	width: 100%;
`;

const ControlsLayout = styled.div<ControlsLayoutProps>`
	width: auto;
	height: auto;
	display: flex;
	justify-content: ${p => p.fullWidth ? 'space-between' : 'flex-start'};
	align-items: center;
`;

const ButtonStyled = styled.button<ButtonProps>`
	display: block;
	width: auto;
	height: 35px;
	border: none;
	background-color: transparent;
	outline: none;
	font-family: 'Roboto';
	font-size: 12px;
	font-weight: ${p => p.isActive ? 500 : 400};
	line-height: 1.36;
	text-transform: uppercase;
	cursor: pointer;
	padding: 0 8px;
	margin: 0;
	max-height: none;
	transition: all .2s ease-in-out;

	${p => `
		color: ${p.theme.color.blackPrimary};
	`}

	${p => p.fullWidth && `
		flex: 1 1 auto;
	`}
`;

const SliderLayout = styled.div`
	width: 100%;
	height: auto;
	margin-top: 6px;
`;

const Slider = styled.div<SliderProps>`
	position: relative;
	width: calc(100% + 80px);
	height: 2px;

	${(p: WithThemeProps) => `
		border-bottom: 1px solid ${p.theme.color.blackStealthy};
	`}

	${(p) => p.negativeOffset && `
		margin: 0 -${p.negativeOffset}px;
	`}
`;

const SliderBar = styled.div<SliderBarProps>`
	position: absolute;
	top: -3px;
	left: ${p => `${p.offset}px`};
	width: ${p => `${p.width}px`};
	height: 4px;
	transition: all .2s ease-in-out;

	${(p: WithThemeProps) => `
		background-color: ${p.theme.color.accentPrimary};
	`}
`;


export {
	Root,
	ControlsLayout,
	ButtonStyled,
	SliderLayout,
	Slider,
	SliderBar
}
